import {
    getReportRouteCostLoading,
    getReportRouteCostReject,
    getReportRouteCostRequest,
    getReportRouteCostSuccess
} from "../../actions/routeCost/getAll";

export const getReportRouteCost = (formData) => async (dispatch, getState) => {
    dispatch(getReportRouteCostLoading());
    try {
        const { data } = await getReportRouteCostRequest(formData, getState);
        dispatch(getReportRouteCostSuccess(data))
    } catch (error) {
        dispatch(getReportRouteCostReject(error))
    }
    return Promise.resolve();
};